import React from 'react';
import { Icon } from 'leaflet';
import moment from 'moment';
import icons from '@core/Icons';
import useDictionary from '@ui/hooks/useDictionary';
import RotatedMarker from './RotatedMarker';
import MarkerPopupComponent from './Marker-popup.component';
import { IMarkerProps } from './IMarkerProps';

interface IProps extends IMarkerProps {
    icon: number;
    highlightedDevice: string | null;
    highlightedCoords: string | null;
    highlightedDate: string | null;
}

const Component: React.FC<IProps> = ({
    icon,
    gpsCoord,
    lbsCoord,
    imei,
    name,
    date,
    gpsDate,
    lbsDate,
    timezone,
    speed,
    dir,
    batteryVoltage,
    highlightedDevice,
    highlightedCoords,
    highlightedDate,
    event,
    temperature,
    cur_sim,
    signal,
    lang,
}: IProps) => {
    const getWord = useDictionary();
    const fileName = icons.getIcon(icon);
    let position = [0, 0];
    let coordsDate = getWord('noData');
    let coordType = getWord('noData');
    if (gpsCoord && gpsCoord.lat && gpsCoord.lon) {
        position = [gpsCoord.lat, gpsCoord.lon];
        coordType = getWord('gps');
        coordsDate = moment(gpsDate)
            .utcOffset(timezone)
            .format('HH:mm DD.MM.YYYY');
    } else if (lbsCoord && lbsCoord.lat && lbsCoord.lon) {
        position = [lbsCoord.lat, lbsCoord.lon];
        coordType = getWord('lbs');
        coordsDate = moment(lbsDate)
            .utcOffset(timezone)
            .format('HH:mm DD.MM.YYYY');
    }
    const [lat, lon] = position.map((v) => v.toFixed(6));
    const coords = `${lat}, ${lon}`;
    const isHighlightedCoords = highlightedCoords === coords;
    const isHighlightedDate = highlightedDate === coordsDate;
    const isHighlightedImei = highlightedDevice === imei;
    const isHighlighted =
        (isHighlightedCoords && isHighlightedDate) || isHighlightedImei;
    const className = isHighlighted ? 'marker__ico_active' : 'marker__ico';
    const markerIcon = new Icon({
        className,
        iconUrl: `public/img/svg/${fileName}`,
        iconSize: [36, 36],
        iconAnchor: [16, 36],
    });
    const isValidCourse = typeof dir === 'number';
    const courseVal = isValidCourse ? dir : 0;

    return (
        <RotatedMarker
            position={position}
            icon={markerIcon}
            rotation={courseVal}
        >
            <MarkerPopupComponent
                gpsCoord={gpsCoord}
                lbsCoord={lbsCoord}
                imei={imei}
                name={name}
                date={date}
                gpsDate={gpsDate}
                lbsDate={lbsDate}
                timezone={timezone}
                speed={speed}
                dir={dir}
                batteryVoltage={batteryVoltage}
                event={event}
                temperature={temperature}
                cur_sim={cur_sim}
                signal={signal}
                lang={lang}
            />
        </RotatedMarker>
    );
};

const MarkerComponent = React.memo(Component);

export default MarkerComponent;
